import React, { useMemo } from 'react';

import classes from './styles.module.scss';

type Type = 'success' | 'error' | 'warning' | 'info';

interface Props {
    type: Type;
    text: string;
    fitContent?: boolean;
}

export default function Alert({ type, text, fitContent }: Props) {
    const alertClass = useMemo(() => {
        switch (type) {
            case 'error':
                return classes.alert_error;
            case 'success':
                return classes.alert_success;
            case 'warning':
                return classes.alert_warning;
            case 'info':
                return classes.alert_info;
        }
    }, [type]);

    const alertIcon = useMemo(() => {
        switch (type) {
            case 'error':
                return (
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                    >
                        <path
                            fillRule='evenodd'
                            d='M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z'
                            clipRule='evenodd'
                        />
                    </svg>
                );
        }
    }, [type]);

    const classList = [classes.alert, alertClass];
    if (fitContent) {
        classList.push(classes.fitContent);
    }

    return (
        <div className={classList.join(' ')}>
            {alertIcon}
            {text}
        </div>
    );
}
